import { Controller } from "@hotwired/stimulus"

// Shows a caret at the foot of the rail's app list while there are apps below the
// fold, and hides it once the list is scrolled to the end (TMS-948). Purely a hint:
// the caret is decorative and not interactive.
export default class extends Controller {
  static targets = ["list", "hint"]

  connect() {
    this.update = this.update.bind(this)
    this.listTarget.addEventListener("scroll", this.update, { passive: true })
    // Catches the cases a scroll event never fires for: the rail being shown again,
    // the window resizing, and web fonts landing after first paint.
    this.observer = new ResizeObserver(this.update)
    this.observer.observe(this.listTarget)
    this.update()
  }

  disconnect() {
    this.listTarget.removeEventListener("scroll", this.update)
    this.observer?.disconnect()
  }

  update() {
    const list = this.listTarget
    const remaining = list.scrollHeight - list.scrollTop - list.clientHeight
    this.hintTarget.hidden = remaining <= 1
  }
}
